// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-item.hover, .dropdown-item:hover, .dropdown-item:focus, .dropdown-item[is-active=true] {\n  color: #fff;\n  text-decoration: none;\n  background-color: #007bff;\n}\n\n::ng-deep .modal .typeahead-dropdown {\n  position: fixed !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
